import { useQuery, useQueryClient } from '@tanstack/react-query';

import { SANDBOX_DEMO_ENABLED } from '@/shared/config';

import { fetchDemoRoster } from '../api/fetchDemoRoster.js';
import { sandboxDemoKeys } from './keys.js';
import { isAnySlotSeeding } from './roster.js';
import { refreshPatientsIfSeedingFinished } from './rosterCache.js';

const SEEDING_POLL_INTERVAL_MS = 3000;

export function useDemoRosterQuery() {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: sandboxDemoKeys.roster,
    // Compared inside the fetch rather than in an effect: several components
    // read the roster, and the patient list should be refetched once per poll.
    // `previous` is read after the fetch, so a seeding roster that
    // `useEnsureDemoPatients` wrote while this request was in flight counts.
    queryFn: async ({ signal }) => {
      const roster = await fetchDemoRoster(signal);
      refreshPatientsIfSeedingFinished(queryClient, roster);
      return roster;
    },
    enabled: SANDBOX_DEMO_ENABLED,
    staleTime: 0,
    refetchInterval: (query) =>
      isAnySlotSeeding(query.state.data) ? SEEDING_POLL_INTERVAL_MS : false,
    meta: { toastOnError: false, sentryOnError: false },
  });
}
